import { ReactComponent as FacebookIcon } from 'src/images/svgs/socials/facebook.svg';
import { ReactComponent as LinkedinIcon } from 'src/images/svgs/socials/linkedin.svg';
import { ReactComponent as TwitterXIcon } from 'src/images/svgs/socials/x-twitter.svg';

import type { SegmentShareEvent } from '../types';

import { type LinkProps, type SocialIconLinks, SocialName, SocialOfficialName } from './page-share.types';

const addUtmParams = (url: string, utmSource: string, utmContent: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}utm_source=${utmSource}&utm_medium=social&utm_campaign=social_share&utm_content=${utmContent}`;
};

const createSharingUrl = {
  twitter: (url: string, description: string) =>
    `https://x.com/intent/post?url=${encodeURIComponent(url)}&text=${encodeURIComponent(
      description,
    )}&via=realtryhackme&hashtags=tryhackme`,
  linkedin: (url: string, description: string) =>
    `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(description)}%0D%0A${encodeURIComponent(
      url,
    )}`,
  facebook: (url: string, description: string) =>
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&t=${encodeURIComponent(description)}`,
};

export const socialIconLinks: Record<SocialName, SocialIconLinks> = {
  [SocialName.twitter]: {
    href: ({ url, description, campaign: { utmContent } }: LinkProps) =>
      createSharingUrl.twitter(addUtmParams(url, 'twitter', utmContent), description),
    icon: TwitterXIcon,
    name: SocialName.twitter,
    officialName: SocialOfficialName.twitter,
  },
  [SocialName.linkedin]: {
    href: ({ url, description, campaign: { utmContent } }: LinkProps) =>
      createSharingUrl.linkedin(addUtmParams(url, 'linkedin', utmContent), description),
    icon: LinkedinIcon,
    name: SocialName.linkedin,
    officialName: SocialOfficialName.linkedin,
  },
  [SocialName.facebook]: {
    href: ({ url, description, campaign: { utmContent } }: LinkProps) =>
      createSharingUrl.facebook(addUtmParams(url, 'facebook', utmContent), description),
    icon: FacebookIcon,
    name: SocialName.facebook,
    officialName: SocialOfficialName.facebook,
  },
};

export const socialTrackEvents: Record<SocialName, SegmentShareEvent> = {
  [SocialName.twitter]: 'share-twitter',
  [SocialName.facebook]: 'share-facebook',
  [SocialName.linkedin]: 'share-linkedin',
};
